import _objectSpread from "@babel/runtime/helpers/objectSpread2";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["className", "size", "selected", "disabled", "label", "htmlProps", "children", "count", "data-testidCount", "subtitle", "withoutUnderline", "styleSelectAround", "showCountOnZero"];
import { clsx } from 'clsx';
import { TAB_CLASSNAMES_BY_SIZE } from "./constants";
import Count from "./Count";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export var Tab = function Tab(_ref) {
  var className = _ref.className,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? 's' : _ref$size,
    selected = _ref.selected,
    disabled = _ref.disabled,
    label = _ref.label,
    htmlProps = _ref.htmlProps,
    children = _ref.children,
    count = _ref.count,
    dataTestIdCount = _ref['data-testidCount'],
    subtitle = _ref.subtitle,
    withoutUnderline = _ref.withoutUnderline,
    styleSelectAround = _ref.styleSelectAround,
    showCountOnZero = _ref.showCountOnZero,
    tabprops = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/_jsxs("button", _objectSpread(_objectSpread(_objectSpread({
    type: "button",
    className: clsx('tw-button-base tw-relative tw-flex tw-items-center tw-justify-center tw-pb-1 tw-px-1.6', TAB_CLASSNAMES_BY_SIZE[size], {
      'dark:tw-text-neutral-dark-500 dark:hover:tw-text-neutral-light-100 tw-text-neutral-light-700': !selected,
      'dark:tw-text-secondary-dark-500 tw-text-primary-light-400': selected,
      'tw-cursor-not-allowed !tw-text-neutral-light-500 dark:!tw-text-neutral-dark-600': disabled,
      'tw-bg-primary-light-100 tw-rounded-1 dark:tw-bg-secondary-light-500 dark:!tw-text-neutral-light-800': styleSelectAround && selected
    }, className),
    disabled: disabled
  }, htmlProps), tabprops), {}, {
    children: [label, count !== undefined && (count > 0 || showCountOnZero) ? /*#__PURE__*/_jsx(Count, {
      count: count,
      "data-testid": dataTestIdCount,
      disabled: disabled,
      selected: selected,
      styleSelectAround: styleSelectAround
    }) : null, subtitle ? /*#__PURE__*/_jsx("span", {
      className: "tw-ml-1 tw-font-caption",
      children: subtitle
    }) : null, children, !withoutUnderline && /*#__PURE__*/_jsx("div", {
      className: clsx('tw-transition-opacity tw-duration-300 tw-absolute tw-bottom-0 tw-inset-x-0 tw-w-full tw-rounded-5 tw-h-[2px] dark:tw-bg-secondary-dark-500 tw-bg-primary-light-400', selected ? 'tw-opacity-1' : 'tw-opacity-0', disabled && '!tw-bg-neutral-light-500 dark:!tw-bg-neutral-dark-600')
    })]
  }));
};
export default Tab;